export const getDefault = () => {
  const schema = {
    name: 'SubWebVideo',
    title: 'Título do video',
    url: 'https://www.youtube.com/watch?v=QbIDx8Hbif0',
    description: 'Descrição do video...',
    disableCookiesCheck: true
  }
  return schema
}
